<div class="struts-content-area" #content></div>